import apiService from './apiService';
import { Get_Token } from 'resolvers/Get_Token';

export async function getOverviewInfo() {
    const response = await apiService.get('/cards/statistics', {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        }
    });
    return response.data;
}
